// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const AccountHeaderFlyout: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 18 19" width={width} height={height}>
            <path
                fill="currentColor"
                d="M14.488 14.896a4.5 4.5 0 0 0-4.363-3.396h-2.25a4.5 4.5 0 0 0-4.363 3.396A7.876 7.876 0 1 1 16.875 9.25a7.85 7.85 0 0 1-2.387 5.646m-1.002.823A7.8 7.8 0 0 1 9 17.125c-1.67 0-3.217-.52-4.49-1.403a3.375 3.375 0 0 1 3.365-3.097h2.25a3.38 3.38 0 0 1 3.364 3.097zM9 18.25a9 9 0 1 0 0-18 9 9 0 0 0 0 18m0-9a1.687 1.687 0 1 1 0-3.375A1.687 1.687 0 0 1 9 9.25M6.188 7.563a2.813 2.813 0 1 0 5.625 0 2.813 2.813 0 0 0-5.625 0"
            />
        </svg>
    );
};

export default React.memo(AccountHeaderFlyout);
